import React, { FC } from 'react';
import { TableRowProps } from '../TableRow/TableRow';

interface TableHeaderProps {
  children: React.ReactElement<TableRowProps>;
}

const TableHeader: FC<TableHeaderProps> = ({ children }) => {
  const headerRow = React.cloneElement(children, { header: true });

  return <thead>{headerRow}</thead>;
};

export default TableHeader;
